import { Position, Point } from '@turf/helpers';

export const pointFromPosition = (position: Position): Point => ({
  type: 'Point',
  coordinates: position,
});
